import React from "react";

const DownloadIcon = ({ ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" {...rest}>
      <path d="M8 2.5V10M8 10L5 7M8 10L11 7" stroke="#212121" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M3 11.5V12.5C3 13.0523 3.44772 13.5 4 13.5H12C12.5523 13.5 13 13.0523 13 12.5V11.5" stroke="#212121" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default DownloadIcon;
